import { Form, Input, ModalProps, FormProps, Modal, Select, InputNumber, useSelect, Row, Col } from '@pankod/refine-antd'
import { useCreateMany, useGetIdentity } from '@pankod/refine-core'
import { useEffect, useState } from 'react'
import type { RangePickerProps } from 'antd/es/date-picker'
import dayjs from 'dayjs'
import { DatePicker } from 'antd'
import { IEvaluationEvaluators } from 'interfaces'
import { createNotificationEvaluationRequest } from 'gql/mutations'
import { useUserContext } from 'context/user'
import { findAlreadyAssignPaperForTestEvent } from 'gql/query'
type CreateThemeProps = {
  modalProps: ModalProps
  formProps: FormProps
  record: any
  userRole?: any
}

export const CreateEvaluationRequest: React.FC<CreateThemeProps> = ({ modalProps, formProps, record, userRole }) => {
  const [allPapers, setAllPapers] = useState<any>([])
  const { data: user } = useGetIdentity()
  const { evaluationInCharge, evaluators } = useUserContext()
  const { mutate } = useCreateMany<IEvaluationEvaluators>()
  const disabledDate: RangePickerProps['disabledDate'] = current => {
    // Can not select days before today and today
    return current && current < dayjs().add(-1, 'day')
  }
  useEffect(() => {
    const findAlreadyAssignedPaper = async () => {
      try {
        if (record?.id) {
          //finding already assigned paper to the test event
          const assignedPapersResposne: any = await findAlreadyAssignPaperForTestEvent(record.id)
          //assigned papers
          const assignedPapers =
            assignedPapersResposne?.test_event_assigned_papers?.map((item: any) => ({
              ...item?.paper,
              assignedPaper: true,
            })) || []
          //available papers
          const availablePapers = record?.papers || []
          //combining both arrays
          setAllPapers([...assignedPapers, ...availablePapers])
        }
      } catch (err) {
        console.log(err, 'error is this')
        setAllPapers([])
      }
    }
    findAlreadyAssignedPaper()
  }, [record, userRole, modalProps.visible])

  const onFinish = async (values: any) => {
    return (
      formProps.onFinish &&
      formProps.onFinish({
        ...values,
        test_event_id: record?.id,
        name: `eid-${Math.floor(1000 + Math.random() * 9000)}-teid-${record?.id?.substring(0, 3)}`,
      })
    )
  }

  return (
    <Modal {...modalProps} title="Assign Evaluation Slot" afterClose={() => formProps.form?.resetFields()}>
      <Form
        {...formProps}
        size="large"
        layout="vertical"
        onFinish={async values => {
          let response = await onFinish(values).then((response: any) => {
            if (response) {
              let array: object[] = []
              values?.evaluator_ids?.forEach((element: any) => {
                array?.push({
                  evaluator_id: element,
                  evaluation_request_id: response?.data?.id,
                })
              })
              mutate({
                resource: 'evaluation_evaluators',
                values: array,
              })
              createNotificationEvaluationRequest(response?.data, user?.id)
            }
          })

          return response
        }}

        // onFinish={onFinish}
      >
        {/* <Row>
          
       </Row> */}
        <Row gutter={[16, 0]}>
          <Col lg={12}>
            <Form.Item label="Slot" name="slot_selected" rules={[{ required: true }]}>
              <DatePicker showTime style={{ width: '100%' }} format="YYYY-MM-DD HH:mm:ss" disabledDate={disabledDate} />
            </Form.Item>
          </Col>
          <Col lg={12}>
            <Form.Item label="Paper" name="paper_id" rules={[{ required: true }]}>
              <Select>
                {allPapers?.length > 0 &&
                  allPapers?.map((item: any) =>
                    item?.status === 'Approved' ? (
                      <option key={item?.id} value={item?.id}>
                        {`#${item?.paper_id}-${item?.paper_smart_id}  ${item.assignedPaper ? '(Assigned Existing Paper)' : ''}`}
                      </option>
                    ) : null
                  )}
              </Select>
              {/* <DatePicker format="YYYY-MM-DD HH:mm:ss" disabledDate={disabledDate} /> */}
            </Form.Item>
          </Col>
          <Col lg={24}>
            <Form.Item label="Evaluation In Charge" name="evaluation_in_charge" rules={[{ required: true }]}>
              <Select>
                {evaluationInCharge.length > 0 &&
                  evaluationInCharge?.map(item => (
                    <option key={item?.id} value={item?.id}>
                      {item?.displayName}
                    </option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          {/* <Col lg={24}>
            <Form.Item label="Evaluators" name="evaluator_ids" rules={[{ required: true }]}>
              <Select mode="multiple">
                {evaluators.length > 0 &&
                  evaluators?.map(item => (
                    <option key={item?.id} value={item?.id}>
                      {item?.displayName}
                    </option>
                  ))}
              </Select>
            </Form.Item>
          </Col> */}
        </Row>

        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
